import React from 'react'
import line from '../DevWork/DevWorkimages/line.png';
import DevWorkMap from './DevWorkimages/DevWorkMap';
const DevWork = () => {
  return (
   <section className="mt-20 sm:mt-24 lg:mt-28 px-4 sm:px-6 lg:px-12">
      {/* === Heading === */}
      <div className="text-center mb-12 sm:mb-16">
        <img
          src={line}
          className="mx-auto pb-4 sm:pb-5 w-24 sm:w-28"
          alt="line"
        />
        <h1 className="text-2xl sm:text-3xl lg:text-4xl leading-snug lg:leading-[55px] text-[#1a202c] font-medium">
          How development <br />
          <span className="font-bold">through Alcaline works</span>
        </h1>
      </div>

      {/* === Process Map === */}
      <DevWorkMap />
    </section>
  )
}

export default DevWork
